import React, { useState } from "react";
import { useFormikContext } from "formik";
import style from "./FormInput.module.scss";
import { Cell } from "styled-css-grid";
import Icon from "Icon";
import classnames from "classnames";
import MaskedInput from 'react-text-mask';
import PasswordOff from "images/password-off.svg";
import PasswordOn from "images/password-on.svg";
import _ from "lodash";

function FormInput({
  getValue,
  label,
  placeholder,
  type,
  questionRef,
  initialValue,
  name = '',
  form: { touched, errors },
  field,
  mask,
  min,
  max,
  onSubmit,
  maxLength,
  validateField,
  isReadOnly,
  noBorderBottom
}) {
  const formik = useFormikContext();
  const [passwordField, setPasswordField] = useState(false);
  const togglePassword = () => setPasswordField(!passwordField);

  function formatPhoneNumber(value) {
    const cleaned = ('' + value).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return match[1] + '-' + match[2] + '-' + match[3];
    }
    return value;
  }

  function formatCreditCardNumber(value) {
    return ('' + value).replace(/\D/g, '');
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name.includes('phone')) {
      formattedValue = formatPhoneNumber(value);
    } else if (name.includes('credit_card_number')) {
      formattedValue = formatCreditCardNumber(value);
    }

    if (getValue) {
      getValue(formattedValue, questionRef);
    } else if (formik && formik.setFieldValue) {
      formik.setFieldValue(name, formattedValue);
    }
  };

  const inputClasses = classnames(
    style.FormInputField,
    noBorderBottom == true && 'nb',
    isReadOnly && style.isReadOnly,
    {
      [style.FormInputErrorField]: errors && errors[field.name] && touched[field.name]
    }
  );

  const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  const cvvMask = Array(6).fill(/\d/);
  const creditCardMask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  const expirationMask = [/\d/, /\d/, '/', /\d/, /\d/];

  const maskDeterminer = () => {
    if (field && field.name) {
      if (field.name.includes('phone')) return phoneMask;
      if (field.name.includes('cvv')) return cvvMask;
      if (field.name.includes('credit_card_number')) return creditCardMask;
      if (field.name.includes('expiration')) return expirationMask;
    }

    if (name && name) {
      if (name.includes('phone')) return phoneMask;
      if (name.includes('phone')) return phoneMask;
      if (name.includes('cvv')) return cvvMask;
      if (name.includes('credit_card_number')) return creditCardMask;
      if (name.includes('expiration')) return expirationMask;
    }

    return mask.split('');
  };

  return (
    <Cell width={12}>
      <label className={style.FormInput}>
        {!mask ? (
          type !== `password` ? (
            <input
              className={inputClasses}
              label={label}
              onBlur={handleChange}
              onKeyDown={(e) => e.keyCode === 13 && onSubmit && onSubmit(e.target.value, questionRef)}
              name={name}
              type={type}
              defaultValue={initialValue == null ? '' : initialValue}
              placeholder={placeholder ? placeholder : label}
              min={min}
              max={max}
              maxLength={maxLength}
              data-hj-whitelist=""
              {...field}
              onKeyUp={validateField}
              readOnly={isReadOnly}
            />
          ) : (
            <input
              className={inputClasses}
              onBlur={handleChange}
              onKeyDown={(e) => e.keyCode === 13 && onSubmit && onSubmit(e.target.value, questionRef)}
              name={name}
              type={passwordField ? `text` : `password`}
              placeholder={placeholder}
              defaultValue={initialValue == null ? '' : initialValue}
              {...field}
            />
          )
        ) : (
          <MaskedInput
            mask={maskDeterminer()}
            className={inputClasses}
            name={name}
            type={type}
            placeholder={placeholder}
            value={initialValue == null ? '' : initialValue}
            guide={false}
            {...field}
            onChange={handleChange}
          />
        )}

        <span className={style.FormInputLabel}>
          {placeholder || label}
        </span>

        {type === 'password' ? <div className={style.FormInputAdditionalCopy}>Password must contain at least one uppercase letter, one number, and one special character.</div> : ''}

        {type === `password` &&
          <div onClick={togglePassword} className={style.FormInputPasswordToggle}>
            {passwordField ?
              <img src={PasswordOn} alt="Hide Password" />
              :
              <img src={PasswordOff} alt="Hide Password" />
            }
          </div>
        }

        {touched && touched[field.name] &&
          errors && errors[field.name] &&
          type !== `password` &&
          <div className={style.FormInputErrorIcon}>
            <Icon icon="error" width={20} height={20} color="#EA2323" />
          </div>
        }
      </label>

      {touched && touched[field.name] &&
        errors && errors[field.name] &&
        <span className={style.FormInputErrorMessage}>{errors[field.name]}</span>
      }
    </Cell>
  );
}

export default FormInput;
